module.exports = __webpack_public_path__ + "static/media/cq_richieste_finanziamenti.85eea0b0.svg";